export function colorizeStyle(color) {
    if(color !== null){
        return {color: color};
    }

    return;
}